import { Link } from 'react-router-dom';
import { FooterListProps } from './FooterList.types';

export default ({ title, list }: FooterListProps) => {
  return (
    <div className="footer__list">
      <span className="footer__listTitle">{title}</span>
      <div className="footer__listBox">
        {list.map(({ label, link }, index) => (
          <Link key={index} className="footer__listItem" to={link || '#'}>
            {label}
          </Link>
        ))}
      </div>
    </div>
  );
};
